import React from "react";

const ProjectsProfile = (props) => {
  const { name, project, link, github,code} = props.pro;

  return (
    <div className="container">
     
      <div className="row justify-content-between">
      <div className="col-8"><h3 className="text-primary">{name}</h3></div>
        
      <div className="col-8"><h6 className="text-secondary">Code Link: {github}</h6></div>
      </div>
      <div className="row justify-content-evenly">
      
        
      </div>
    </div>
  );
};

export default ProjectsProfile;
